module.exports = __webpack_public_path__ + "img/OFFLINE2.5e6ab15c.png";